import '../App.css';
import React, { useState } from 'react';
import Hero from '../components/Hero';
import DeepOrbCapabilities from '../components/DeepOrbCapabilities';



export const Tabs = ({ children }) => {
  const tabs = React.Children.toArray(children);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div>
      {/* Tab headers */}
      <div className="flex border-b">
        {tabs.map((tab, idx) => {
          const title = tab.props.title || `Tab ${idx + 1}`;
          const isActive = idx === activeIndex;
          return (
            <button
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className={
                `px-4 py-2 -mb-px font-medium focus:outline-none ` +
                (isActive
                  ? 'border-b-2 border-indigo-600 text-indigo-600'
                  : 'text-gray-600 hover:text-gray-800')
              }
            >
              {title}
            </button>
          );
        })}
      </div>

      {/* Active tab content */}
      <div className="p-4">
        {tabs[activeIndex]}
      </div>
    </div>
  );
};

export const HomePage = ({config}) => {
  const [account, setAccount] = useState(null);
  return (
    <>
      <Hero />
      <DeepOrbCapabilities />
      {/* <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-6">Welcome to Our Platform</h2>
          <p className="text-lg text-gray-700 mb-8">
            Explore the features and capabilities of our application. Use the tabs below to navigate through different sections.</p>
        </div>  
      </section> */}
    </>
  );
}

